import { http } from '@/utils/axios'

/**
 * @msg: 选择上报课程列表 http://localhost:8081/zkfz/ZkolScoreReportBatch/getReportCourse?courseName=&courseCode=&classCode=20220520001&courseAttribute=&rkTeacherName=&rkMhmName=&checkTimeBegin=&checkTimeEnd=&partnerInstitution=&partnerSchool=&examinationType&videoTypeTitle&uid=1&page=1&pageSize=20
 */
export function getReportCourse(data) {
    return http({
        url: http.baseUrl('ZkolScoreReportBatch/getReportCourse'),
        method: 'get',
        params: http.params(data),
    })
}

/**
 * @msg: 设置 | 修改上报时间 http://localhost:8081/zkfz/ZkolScoreReportBatch/saveReportBatch?courseName=&courseCode=&classCode=&courseAttribute=&rkTeacherName=&rkMhmName=&checkTimeBegin=&checkTimeEnd=&partnerInstitution=&partnerSchool=&examinationType&videoTypeTitle&uid=1&page=1&pageSize=20&reportTime=2022-08-15&ids=cc35b2b63435401dbefcc048a93ec65e,9b2d04321d86486889380dc94a67863e
 */
 export function saveReportBatch(data) {
    return http({
        url: http.baseUrl('ZkolScoreReportBatch/saveOrUpdateReportBatch'),
        method: 'get',
        params: http.params(data),
    })
}

/**
 * @msg: 导出筛选结果 http://localhost:8081/zkfz/ZkolScoreReportBatch/exportExcel?courseName=&courseCode=&classCode=&courseAttribute=&rkTeacherName=&rkMhmName=&checkTimeBegin=&checkTimeEnd=&partnerInstitution=&partnerSchool=&examinationType&videoTypeTitle&uid=1&reportTime=
 */
 export function exportExcel(data) {
    return http({
        url: http.baseUrl('ZkolScoreReportBatch/exportExcel'),
        method: 'get',
        params: http.params(data),
    })
}


/**
 * @msg: 上报批次列表 http://localhost:8081/zkfz/ZkolScoreReportBatch/statisticsReportBatch?reportTime=20220815&page=1&pageSize=20&uid=1
 */
 export function statisticsReportBatch(data) {
    return http({
        url: http.baseUrl('ZkolScoreReportBatch/statisticsReportBatch'),
        method: 'get',
        params: http.params(data),
    })
}


/**
 * @msg: 上报成绩查询  http://localhost:8081/zkfz/zkolScoreReportRecord/getList?uid=1&page=1&pageSize=10
 */
 export function getReportList(data) {
    return http({
        url: http.baseUrl('zkolScoreReportRecord/getList'),
        method: 'get',
        params: http.params(data),
    })
}

/**
 * @msg: 参加上报考核成绩  http://localhost:8081/zkfz/zkolScoreReportRecord/saveScoreReportRecord?batchId=55470b5354c4432b91f189c2e6e61848&videoId=970&uid=19346
 */
 export function saveScoreReportRecord(data) {
    return http({
        url: http.baseUrl('zkolScoreReportRecord/saveScoreReportRecord'),
        method: 'post',
        params: http.params(data),
    })
}

/**
 * @msg: 参加上报按钮控制  http://localhost:8081/zkfz/zkolScoreReportRecord/checkScoreReportTime?batchId=888ab79106d54939b58f0184370c22ec&videoId=911&uid=1
 */
 export function checkScoreReportTime(data) {
    return http({
        url: http.baseUrl('zkolScoreReportRecord/checkScoreReportTime'),
        method: 'post',
        params: http.params(data),
    })
}

/**
 * @msg: 查看历史上报记录  http://localhost:8081/zkfz/zkolScoreReportRecord/getScoreReports?batchId=888ab79106d54939b58f0184370c22ec&videoId=911&uid=1
 */
 export function getScoreReports(data) {
    return http({
        url: http.baseUrl('zkolScoreReportRecord/getScoreReports'),
        method: 'get',
        params: http.params(data),
    })
}